import React from 'react';
import { submitQueriesStream } from '@services/genaiQueriesV2';
import { logFormSubmit } from '@utils/usefulFuncs';

const ACTIONS = {
  init: 'init',
  update: 'u',
};

function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.init: {
      return action.payload;
    }

    case ACTIONS.update: {
      const section = action.payload;
      const nextState = [];
      state?.forEach((s) => {
        if (s.heading !== section.heading) {
          nextState.push(s);
        } else {
          nextState.push(section);
        }
      });
      return nextState;
    }

    default:
      throw new Error();
  }
}

export const useMultiplePrompts = (docs, sections, model, tool) => {
  const [state, dispatch] = React.useReducer(reducer, sections, () => sections);

  React.useEffect(() => {
    const fetch = async (section, model) => {
      const { prompt } = section;
      const docIds = docs.map((d) => d.id);
      const settings = { model, user_mode: tool };
      logFormSubmit({ ...settings, question: prompt, doc_ids: docIds });
      const result = await submitQueriesStream({
        questions: prompt,
        docIds,
        settings,
      });

      if (result.status === 200) {
        dispatch({
          type: ACTIONS.update,
          payload: {
            ...section,
            resultId: result.runId,
          },
        });
      }
    };

    if (docs) {
      sections.forEach((s, i) => {
        setTimeout(() => {
          fetch(s, model);
        }, 1 + i * 700);
      });
    }
  }, [model, docs]);

  return state;
};
